module.exports = __webpack_public_path__ + "img/HT.05020bb8.svg";